import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import csc from 'country-state-city';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { AppConstants } from 'src/app/_helpers/app.constants';
@Component({
  selector: 'app-newusercontact',
  templateUrl: './newusercontact.component.html',
  styleUrls: ['./newusercontact.component.css']
})
export class NewusercontactComponent extends BaseComponent implements OnInit {

  getTypeUserobj;
  getCountryobj;
  getCompanyobj;
  getRoleObj;
  uid;
  isactive
  selectedid;
  selectedname;
  select_role_name;
  header = "Add New"
  constructor(
    private formBuilder: FormBuilder
  ) {
    super();
  }
  status: boolean = true;
  registerForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  userProfileDetails;

  userObjId;
  summaries;
  countriesData;
  stateData;
  cityData;
  ngOnInit() {
    this.ngxSpinnerService.show();
    this.countriesData = csc.getAllCountries() || [];
    this.getUserProfileDetails();
    this.getTypeOfUsers();
    this.getCountry();
    this.getCompany();
    this.uid = this.activatedRoute.snapshot.queryParams['uid'];
    this.activatedRoute.queryParams.subscribe(params => {
      this.uid = params.uid;
    });

    this.registerForm = this.formBuilder.group({
      fname: ['', Validators.required],
      lname: [],
      pemail: ['', [Validators.required, Validators.email]],
      semail: ['', Validators.email],
      hphone: [],
      mphone: ['', [Validators.required, Validators.minLength(12)]],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', [Validators.required, Validators.pattern(AppConstants.regex.number),
        Validators.minLength(4), Validators.maxLength(10)]],
      region: [],
      country: ['', Validators.required],
      company: ['', Validators.required],
      roleid: ['', Validators.required]
    });

    if (this.uid) {
      this.header = "Edit";
      this.status = false;
      this.registerService.getUserById(this.uid).subscribe(response => {
        if (response.status) {
          this.userObjId = this.normalizeUserDetails(response.data);
          this.dataBinding();
        }
        this.ngxSpinnerService.hide();
      }, error => {
        this.ngxSpinnerService.hide();
      });
      this.UpdateUserLogData();
    } else {
      this.addUserLogData();
    }
  }

  formChange() {
    if (this.userProfileDetails.company_name == 'margo') {
      this.registerForm.get('company').setValidators([Validators.required]);
    } else {
      this.registerForm.get('company').clearValidators();
    }
    this.registerForm.get('company').updateValueAndValidity();
  }





  resolveCountrySortname(value) {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const raw = String(value).trim();
    if (!raw) {
      return '';
    }
    const countries = this.countriesData || [];
    const bySort = countries.find(c => String(c.sortname).toUpperCase() === raw.toUpperCase());
    if (bySort) {
      return bySort.sortname;
    }
    const byName = countries.find(c => String(c.name).toLowerCase() === raw.toLowerCase());
    if (byName) {
      return byName.sortname;
    }
    const byCscId = countries.find(c => String(c.id) === raw);
    if (byCscId) {
      return byCscId.sortname;
    }
    const master = (this.getCountryobj || []).find(c => String(c.country_id) === raw);
    if (master) {
      if (master.country_code) {
        const byCode = countries.find(c => String(c.sortname).toUpperCase() === String(master.country_code).toUpperCase());
        if (byCode) {
          return byCode.sortname;
        }
      }
      if (master.country_name) {
        const byMasterName = countries.find(c => String(c.name).toLowerCase() === String(master.country_name).toLowerCase());
        if (byMasterName) {
          return byMasterName.sortname;
        }
      }
    }
    return raw;
  }

  loadStateCityOptions(countryValue, stateValue) {
    this.stateData = [];
    this.cityData = [];
    const sortname = this.resolveCountrySortname(countryValue);
    if (!sortname) {
      return sortname;
    }
    const ct = (this.countriesData || []).find(elem => elem.sortname === sortname);
    if (!ct) {
      return sortname;
    }
    this.stateData = csc.getStatesOfCountry(ct.id) || [];
    if (!stateValue) {
      return sortname;
    }
    const st = this.stateData.find(elem => String(elem.name).toLowerCase() === String(stateValue).toLowerCase());
    if (st) {
      this.cityData = csc.getCitiesOfState(st.id) || [];
    }
    return sortname;
  }

  states(id) {
    if (this.registerForm) {
      this.f.state.setValue('');
      this.f.city.setValue('');
    }
    this.loadStateCityOptions(id, '');
  }

  getCities(id) {
    if (this.registerForm) {
      this.f.city.setValue('');
    }
    this.cityData = [];
    if (!id || !this.stateData || !this.stateData.length) {
      return;
    }
    const st = this.stateData.find(elem => String(elem.name).toLowerCase() === String(id).toLowerCase());
    if (!st) {
      return;
    }
    this.cityData = csc.getCitiesOfState(st.id) || [];
  }

  addUserLogData() {

    let UserLogs = {
      log_type: "Adding New User",
      log_name: "Adding New User",
      log_description: "Adding New User",
      moduleid: 1,
      moduleitemid: 7,
      per_id: 14
    }
    this.logs.addNewLogs(UserLogs).subscribe(data => {
      this.ngxSpinnerService.hide();
    }, error => {
     // console.log(error);
      this.ngxSpinnerService.hide();
    });

  }

  UpdateUserLogData() {

    let UserLogs = {
      log_type: "Updating User Data",
      log_name: "Updating User Data",
      log_description: "Updating User Data",
      moduleid: 1,
      moduleitemid: 7,
      per_id: 14
    }

    this.logs.addNewLogs(UserLogs).subscribe(data => {
      this.ngxSpinnerService.hide();

    }, error => {
     // console.log(error);
      this.ngxSpinnerService.hide();
    });

  }
  getUserProfileDetails() {
    let self = this;
    self.registerService.getUserProfileDetails().subscribe(data => {
      if (data.status) {
        //self.status = true;
        self.userProfileDetails = data.data;
        this.getRole();
        this.formChange();
      }
    }, error => {

    });
  }

  addNewUser() {
    let self = this, company_id = 0;
    this.submitted = true;

    if (self.userProfileDetails.admin_customer_id === 0) {
      company_id = this.f.company.value;
    } else {
      company_id = self.userProfileDetails.admin_customer_id;
    }
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    let addUser = {
      fname: this.f.fname.value,
      lname: this.f.lname.value || "",
      //username: this.f.pemail.value,
      email: this.f.pemail.value,
      email_primary: this.f.pemail.value,
      email_secondary: this.f.semail.value || "",
      home_phone: this.f.hphone.value || "",
      mobile_phone: this.f.mphone.value,
      // birthdate: this.f.birthdate.value,
      // marid: this.f.marital.value,
      // title: this.f.title.value,
      // sexid: this.f.sex.value,
      // address1: this.f.address1.value,
      // address2: this.f.address2.value,
      city: this.f.city.value,
      state: this.f.state.value,
      zipcode: this.f.zip.value || "",
      region: this.f.region.value || "",
      country: this.f.country.value,
      // facebook_id: this.f.fb.value,
      // twitter_id: this.f.twitter.value,
      // linkedin_id: this.f.linkedin.value,
      // instagram_id: this.f.instagram.value,
      // instagram_biz_id: this.f.ibiz.value,
      // youtube_id: this.f.youtube.value,
      // google_my_biz_id: this.f.gbiz.value,
      // sina_wiebo_id: this.f.sinawiebo.value,
      // we_chat_id: this.f.wechat.value,
      // whatsapp_id: this.f.whatsapp.value,
      roleid: this.f.roleid.value,
      company: company_id, // this.f.company.value,
      typeid: 1 //this.f.usertype.value,
    }
    //console.log(addUser);
    this.ngxSpinnerService.show();
    this.registerService.createUser(addUser).subscribe(data => {
      if (data.status) {
        this.toastrService.success("Please Verify Your E-mail To Activate Your Account");
        this.router.navigateByUrl(`/corporate/users`);
      } else {
        this.toastrService.error(data.message)
      }
      this.ngxSpinnerService.hide();
    }, error => {
     // console.log(error);
      this.ngxSpinnerService.hide();
    })
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  normalizeUserDetails(data) {
    if (!data) {
      return null;
    }
    let user = data.get_admin_user_details_by_id || data;
    if (typeof user === 'string') {
      try {
        user = JSON.parse(user);
      } catch (e) {
        return null;
      }
    }
    if (Array.isArray(user)) {
      user = user[0];
    }
    return user || null;
  }

  dataBinding() {
    if (!this.userObjId || !this.registerForm) {
      return;
    }
    const country = this.loadStateCityOptions(this.userObjId.country, this.userObjId.state);
    this.selectedname = this.userObjId.role_name;
    const companyVal = (this.userObjId.customer_id !== null && this.userObjId.customer_id !== undefined && this.userObjId.customer_id !== '')
      ? this.userObjId.customer_id
      : (this.userObjId.admin_customer_id !== null && this.userObjId.admin_customer_id !== undefined ? this.userObjId.admin_customer_id : '');
    this.registerForm.patchValue({
      fname: this.userObjId.admin_fname || '',
      lname: this.userObjId.admin_lname || '',
      pemail: this.userObjId.email_primary || this.userObjId.admin_email || '',
      semail: this.userObjId.email_secondary || '',
      hphone: this.userObjId.home_phone || '',
      mphone: this.userObjId.mobile_phone || '',
      city: this.userObjId.city || '',
      state: this.userObjId.state || '',
      zip: this.userObjId.zipcode || '',
      region: this.userObjId.region || '',
      country: country || '',
      company: companyVal,
      roleid: this.userObjId.role_id || ''
    });
  }

  updateUserDetails() {
    let self = this, company_id = 0;
    this.submitted = true;

    if (self.userProfileDetails.customer_id === 0) {
      company_id = this.f.company.value;
    } else {
      company_id = self.userProfileDetails.customer_id;
    }
  //  console.log(this.registerForm);

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    // this.submitted = true;
   // console.log(this.registerForm.invalid);

    // stop here if form is invalid
    //  if (this.registerForm.invalid) {
    //   return;
    // }

    let userObject = {
      fname: this.f.fname.value,
      lname: this.f.lname.value,
      email: this.f.pemail.value,
      email_primary: this.f.pemail.value,
      email_secondary: this.f.semail.value || "",
      home_phone: this.f.hphone.value || "",
      mobile_phone: this.f.mphone.value,
      city: this.f.city.value,
      state: this.f.state.value,
      zipcode: this.f.zip.value || "",
      region: this.f.region.value || "",
      country: this.f.country.value,
      customerid: this.f.company.value,
      roleid: this.f.roleid.value,
      typeid:1, // this.f.usertype.value,
      id: Number.parseInt(this.uid, 10),
      isactive: this.userObjId.isactive
    };
   // console.log(userObject);
    this.ngxSpinnerService.show();
    this.registerService.updateUser(userObject).subscribe(data => {
      if (data.status) {
        this.toastrService.success("Updated Successfully");
        this.router.navigateByUrl(`/corporate/users`);
      } else {
        this.toastrService.error(data.message);
      }
      this.ngxSpinnerService.hide();
    }, error => {
      console.error(error);
      this.ngxSpinnerService.hide();
    });
  }

  getTypeOfUsers() {
    let self = this;
    this.registerService.getType().subscribe(data => {
      self.getTypeUserobj = data.data;
    }, error => {
     // console.log(error);
    });
  }

  getCountry() {
    this.registerService.getCountryData().subscribe(data => {
      this.getCountryobj = data.data || [];
      if (this.uid && this.userObjId) {
        this.dataBinding();
      }
    }, error => {
      this.getCountryobj = [];
      if (this.uid && this.userObjId) {
        this.dataBinding();
      }
    });
  }

  getCompany() {
    let self = this;
    this.registerService.getCompanyData().subscribe(data => {
      self.getCompanyobj = data.data;
    }, error => {
     // console.log(error);
    });
  }
  // getRole() {
  //   let self = this;
  //   this.registerService.getRoleData().subscribe(data => {
  //     self.getRoleObj = data.data;
  //     console.log(self.getRoleObj)
  //   }, error => {
  //     console.log(error);
  //   });
  // }
  onEvent(event) {
    this.selectedid = event.node.data.id;
    this.selectedname = event.node.data.name;
   // console.log(this.selectedid, this.selectedname)
  }

  getRole() {
    let self = this;
    this.registerService.getRoleData().subscribe(data => {
      var getRoleObj = data.data;
      console.log('ROLE OBJ', getRoleObj);
      var obj = [];
      let superobj = {
        id: 0,
        name: "Role",
        children: []
      }
      for (let index = 0; index < getRoleObj.length; index++) {
        const element = getRoleObj[index];
        if (element.get_master_role_parent_id_fun.level === 0 &&
          element.get_master_role_parent_id_fun.role_parent === 0) {

          var child = {
            id: element.get_master_role_parent_id_fun.role_id,
            name: element.get_master_role_parent_id_fun.role_name
          }
          //element.children = element.children == undefined ? [] : element.children;
          superobj.children.push(child);
        }
      }
      obj.push(superobj);
      getRoleObj.forEach(element => {
        element = element.get_master_role_parent_id_fun;
        var each = {
          id: element.role_id,
          name: element.role_name,
          children: []
        };
        if (element.level == 0) {
          for (var i = 0; i < getRoleObj.length; i++) {
            if (getRoleObj[i].get_master_role_parent_id_fun.level == 1 &&
              getRoleObj[i].get_master_role_parent_id_fun.role_parent == element.role_id) {

              var child = {
                id: getRoleObj[i].get_master_role_parent_id_fun.role_id,
                name: getRoleObj[i].get_master_role_parent_id_fun.role_name
              }
              //element.children = element.children == undefined ? [] : element.children;
              each.children.push(child);
            }
          }
          obj.push(each);
        }
      //  console.log(obj);
      });

      obj.shift();
      if (this.userProfileDetails.role_id === 86) {
        obj = obj.filter(elem => elem.name === "Client HQ");
        let chd = obj[0].children;
        let chfn = chd.filter (elem => elem.name !== 'Superadmin');
        obj[0].children = chfn;
      }
      if (this.userProfileDetails.role_id === 78) {
        obj.filter(elem => elem.name === "Client BU");
        obj = obj.filter(elem => elem.name === "Client BU");
        let chd = obj[0].children;
        let chfn = chd.filter (elem => elem.name !== 'Superadmin');
        obj[0].children = chfn;
      }
      self.getRoleObj = obj;
    });
  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true; }
}




